import React, { useContext } from "react"

import { Redirect } from "react-router-dom"

import TutorContext from "~Tutor/TutorContext"

import Messaging from "components/Messaging"
import { path } from "components/Tutor/TutorRoutes"

const TutorMessaging: React.FC = () => {
  const {
    viewer: { messagingDisabled },
  } = useContext(TutorContext)

  if (messagingDisabled) return <Redirect to={path("dashboard")} />

  return <Messaging />
}

export default TutorMessaging
